import React from 'react';
import styled from 'styled-components';
import { OutlinedIcon } from '@gr-monorepo/common/public/assets/icons';
import Card from 'features/shared/ui/Card';
import { H3 } from 'features/shared/ui/Heading';

const UnavailableCard = styled(Card).attrs({ $padding: 24 })`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-height: 368px;
  gap: 16px;
  text-align: center;
`;

const UnavailableIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: block;
    width: 92px;
    height: 92px;
  }
`;

const UnavailableDescription = styled.p`
  margin: 0;
  color: var(--black-60);
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
`;

const OlympiadsStatisticsUnavailable = () => (
  <UnavailableCard data-testid="olympiads-statistics-unavailable">
    <UnavailableIcon>
      <OutlinedIcon />
    </UnavailableIcon>
    <H3>Статистика появится позже</H3>
    <UnavailableDescription>
      Вы можете посмотреть результаты олимпиад за предыдущий период
    </UnavailableDescription>
  </UnavailableCard>
);

export default OlympiadsStatisticsUnavailable;